import React from "react";
import { Container, Stack } from "@mui/material";
import BasketCheckoutPanel from "../components/BasketCheckoutPanel";
import { useSupply } from "../context/SupplyContext";

export default function BasketCheckoutPage() {
  const { basket, setBasket } = useSupply();
  const strategy = basket?.strategy ?? "CHEAPEST_BASKET";

  return (
    <Container sx={{ py: 4 }}>
      <Stack spacing={3}>
        <BasketCheckoutPanel
          strategy={strategy}
          onStrategyChange={(next) => setBasket({ ...basket, strategy: next })}
          onCheckout={() => undefined}
        />
      </Stack>
    </Container>
  );
}
